export default __webpack_public_path__ + "06d83d62d9e9128a35c94ab80feda890.png";